
import { supabase } from '@/integrations/supabase/client';

export class SessionValidator {
  private static instance: SessionValidator;
  private lastValidation: number = 0;
  private validationCache: boolean = false;
  private static VALIDATION_CACHE_TIME = 30000; // 30 segundos

  static getInstance(): SessionValidator {
    if (!SessionValidator.instance) {
      SessionValidator.instance = new SessionValidator();
    }
    return SessionValidator.instance;
  }

  async isValidSession(): Promise<boolean> {
    const now = Date.now();
    
    // Usar cache se a validação foi recente
    if (now - this.lastValidation < SessionValidator.VALIDATION_CACHE_TIME) {
      return this.validationCache;
    }

    try {
      const { data: { session }, error } = await supabase.auth.getSession();
      
      if (error) {
        console.error('Erro ao validar sessão:', error);
        this.validationCache = false;
        this.lastValidation = now;
        return false;
      }

      const isValid = !!session && !!session.user;
      
      // Verificar se o token não está expirado
      if (isValid && session) {
        const expiresAt = session.expires_at ? session.expires_at * 1000 : 0;
        const isNotExpired = expiresAt > now;
        
        this.validationCache = isNotExpired;
      } else {
        this.validationCache = false;
      }

      this.lastValidation = now;
      return this.validationCache;
    } catch (error) {
      console.error('Erro na validação de sessão:', error);
      this.validationCache = false;
      this.lastValidation = now;
      return false;
    }
  }

  async refreshSessionIfNeeded(): Promise<boolean> {
    try {
      const { data: { session } } = await supabase.auth.getSession();
      
      if (!session) return false;

      const now = Date.now();
      const expiresAt = session.expires_at ? session.expires_at * 1000 : 0;
      const timeUntilExpiry = expiresAt - now;
      
      // Renovar se expira em menos de 5 minutos
      if (timeUntilExpiry < 300000) {
        const { data, error } = await supabase.auth.refreshSession();
        
        if (error) {
          console.error('Erro ao renovar sessão:', error);
          return false;
        }

        return !!data.session;
      }

      return true;
    } catch (error) {
      console.error('Erro ao renovar sessão:', error);
      return false;
    }
  }

  clearCache(): void {
    this.lastValidation = 0;
    this.validationCache = false;
  }
}
